/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from 'styled-components';
import {
  desktopVW, minTablet, mobileVW,
} from '../../styles';
import { InputField } from '../../shared/Inputs';

export const PersonSelector = ({ data, value, handleQuantity } : any) => (
  <StyledPersonSelector>
    <InputField type="number" pattern="[0-9]*" onChange={(e : any) => handleQuantity(e.target.value)} value={value} title={data.inputField} />
  </StyledPersonSelector>
);

const StyledPersonSelector = styled.div`
  margin-top: ${mobileVW(30)};
  position: relative;

  ${minTablet} {
    margin-top: ${desktopVW(30)};
  }
`;
